(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/numbergames/game-app/assets/javascripts/app.js') >= 0) return;  svs.modules.push('/components/numbergames/game-app/assets/javascripts/app.js');

'use strict';

const {
  productMapping
} = svs.numbergames;
const gameNavigationEl = 'numbergames-game-navigation';
const App = Marionette.Application.extend({
  region: '#ngMainRegion',
  onStart(app, _ref) {
    let {
      product,
      Router
    } = _ref;
    this.itemsMenu = new svs.ui.ItemsMenu({
      el: gameNavigationEl,
      class: gameNavigationEl,
      useScrollHelpers: svs.core.detect.formfactor.desktop(),
      useScrollFaders: true,
      showScrollbar: false,
      scrollToSelected: true,
      clickCallback(item) {
        const actionValue = !item['data-route'] ? 'enkelrader' : item['data-route'];
        svs.components.analytics.trackEvent({
          category: "".concat(productMapping.getProductName(product), " Page"),
          action: actionValue.replace(/-/g, '_'),
          opt_label: 'click menu'
        });
        const syndicateId = svs.utils.paramHandler.get({
          key: 'syndicateId'
        }).value;
        const link = "".concat(item['data-route'] || '').concat(syndicateId ? "?syndicateId=".concat(syndicateId) : '');
        Backbone.history.navigate(link, {
          trigger: true
        });
      }
    });
    this.listenTo(Backbone.history, 'route', () => {
      this.updateItemsMenu(Backbone.history.fragment);
    });
    if (Router) {
      svs.numbergames.game_app.router = new Router({
        app: this
      });
      Backbone.History.started || Backbone.history.start({
        pushState: true,
        root: svs.core.data.baseUrl
      });
    }
  },
  updateItemsMenu(route) {
    var _route$split$, _route, _route$split;
    route = route.replace(/\?.*/, '');
    route = (_route$split$ = (_route = route) === null || _route === void 0 || (_route$split = _route.split) === null || _route$split === void 0 ? void 0 : _route$split.call(_route, '/')[0]) !== null && _route$split$ !== void 0 ? _route$split$ : route;
    const gameNavigation = document.querySelector(".".concat(gameNavigationEl));
    if (gameNavigation) {
      const items = gameNavigation.querySelectorAll('.js-items-menu-item');
      const itemIndex = [...items].findIndex(item => item.dataset.route === route);
      if (itemIndex > -1) {
        this.itemsMenu.setSelectedItemByIndex(itemIndex, true);
      }
    }
  }
});
svs.numbergames.game_app.app = new App();

 })(window);